import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=4b2e8253"
import script from "./ListDetail.vue?vue&type=script&lang=js"
export * from "./ListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports